<template>
  <div class="createAn7-box">
    <div class="createAn7-title intro-x">{{loading8 ? '正在创建应用':'创建成功'}}</div>
 
    <div class="createAn7-content intro-x">
      {{msg}}
    </div>
    <div class="createAn7-icon ">
      <LoadingIcon v-if="loading8" icon="oval" class="w-8 h-8 intro-x"  />

      <i v-else class="el-icon-success intro-x" style="color:#1890FF;font-size:73px"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ["loading8",'appData'],
  data() {
    return {};
  },
  computed:{
    msg: function(){
      return this.appData.pay_mode === '0' ? '应用已创建完成，仅差完成授信实名认证即可获得账号当前信用分与专属信用额度' :'创建成功后即可前往我的应用页面查看新创建的应用噢，进行更加详细的编辑'
    }
  }
};
</script>

<style lang="scss" scoped>
.createAn7-box {
  margin-top: 60px;
  .createAn7-title {
    font-size: 16px;
    color: #333333;
    text-align: center;
  }
  .createAn7-content {
    font-size: 12px;
    color: #999999;
    width: 302px;
    text-align: center;
    margin: 8px auto 14px;
  }
  .createAn7-icon {
    height: 73px;
    width: 73px;
    margin: auto;
  }
}
</style>